import React from 'react';
import { CommonFAQ, ImportantNotice } from '../SearchAndResults/StaticSections';

import everest from './everest';
import { appendHoneyGuide } from '../../../lib/utils';
import { metaDescription, subTitle, sectors } from './common';

const pageTitle = 'Book Flights in the Nepal Himalayas';

const all = {
  pageTitle,
  subTitle,
  CreditMessage: () => (
    <p className="text-center ext-word">
      *Get USD <strong>8-11</strong> in HoneyGuide Credits with every ticket
      purchase.
    </p>
  ),
  seo: {
    title: appendHoneyGuide(pageTitle),
    description: metaDescription.concat(
      'Online Flight Booking in the Moutains of Nepal'
    ),
    image:
      'https://s3.amazonaws.com/honeyguide/assets/book-lukla-flights-new.jpg',
  },
  from: 'KTM',
  to: 'LUA',
  valueProps: everest.valueProps,
  sectors,
  Notice: () => <ImportantNotice />,
  Faq: () => (
    <React.Fragment>
      <CommonFAQ />
    </React.Fragment>
  ),
  lodge: {
    ...everest.lodge,
  },
};

export default all;



// WEBPACK FOOTER //
// ./src/screens/Flights/static-db/all.js